<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada?.turma?.franquia?.descricao || ''}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <v-dialog
                        ref="dateDialog"
                        v-model="modal"
                        :return-value.sync="dataAulaDuplicada"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label>Selecione uma data</e-label>
                          <v-text-field
                            dense
                            solo
                            v-model="data_aula"
                            label="Data"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          scrollable
                          :allowed-dates="allowedDates"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dateDialog.save(dataAulaDuplicada)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="gestaoDeAula.tipo_de_aula !== 'Aula Remota'"
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horariosFiltrados"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row v-if="!gestaoDeAula.e_aula_infantil === 1 || !gestaoDeAula.e_aula_infantil">
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Conteúdo</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.conteudo }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.metodologia }}
                    </p>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  style="max-height: 200px; overflow-y: auto"
                  class="elevation-1 rounded mb-4"
                >
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Campos de experiências</e-label>
                    <ul
                      v-for="(item, index) in gestaoDeAula.campos_de_experiencias.filter((i) => i)"
                      :key="index"
                    >
                      <li>
                        {{ item }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Estratégias de ensino</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.estrategias }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Recursos</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.recursos }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Atividade de casa</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.atividade_casa }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium">Observações</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.observacoes }}
                    </p>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      gestoesFiltradas: [],
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },

      horarios: [],
      date: null,
      // horarioSelecionado: null,
      horariosFiltrados: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        this.horarios = val.turma.horarios;
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );

            this.gestoesFiltradas = gestoes.filter(
              (gestao) => gestao.turma_id !== this.gestaoDeAula.turma_id
            );

            this.turmas = this.gestoesFiltradas;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data_aula = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
    },
  },
  methods: {
    allowedDates(date) {
      if (!this.turmaSelecionada || !this.turmaSelecionada.relacoesDiasHorarios) {
        return false;
      }

      const dayOfWeek = new Date(date).getDay();

      const diasPermitidos = this.turmaSelecionada.relacoesDiasHorarios.map((rel) => rel.dia.id);

      return diasPermitidos.includes(dayOfWeek);
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.turmaSelecionada?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          horariosDoDia = this.turmaSelecionada.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (!this.turmaSelecionada.turma.id) {
        this.$toast.danger("Por favor, selecione uma turma");
        return;
      }

      if (!this.dataAulaDuplicada) {
        this.$toast.danger("Por favor, selecione uma data");
        return;
      }

      if (this.gestaoDeAula.tipo_de_aula !== "Aula Remota" && !this.horarioSelecionado.id) {
        this.$toast.danger("Por favor, selecione um horário");
        return;
      }

      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.gestaoDeAula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>
